var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { DecimalInput } from '../DecimalInput';
/**
 * @deprecated
 * Use `CurrencyInput` to render a decimal input with currency sign already in place.
 *
 * __It uses same props as Decimal Input__
 */
var CurrencyInput = function (_a) {
    var _b = _a.prefix, prefix = _b === void 0 ? '$' : _b, autoFocus = _a.autoFocus, _c = _a.alignText, alignText = _c === void 0 ? 'initial' : _c, _d = _a.minDecimalScale, minDecimalScale = _d === void 0 ? 2 : _d, onKeyDown = _a.onKeyDown, otherProps = __rest(_a, ["prefix", "autoFocus", "alignText", "minDecimalScale", "onKeyDown"]);
    return (React.createElement(DecimalInput
    // This component has no functionality but providing some default settings for currency type decimal input. So it is save to pass otherProps
    // eslint-disable-next-line react/jsx-props-no-spreading
    , __assign({}, otherProps, { prefix: prefix, minDecimalScale: minDecimalScale, alignText: alignText, onKeyDown: onKeyDown, autoFocus: true })));
};
export default CurrencyInput;
//# sourceMappingURL=CurrencyInput.js.map